import { render, staticRenderFns } from "./AppBottomServices.vue?vue&type=template&id=4c4ab369"
import script from "./AppBottomServices.vue?vue&type=script&lang=js"
export * from "./AppBottomServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports